/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography} from '@mui/material';

import {FullnessProps} from '../../types';
import {BLOCK_HEIGHT, BLOCK_HEIGHT_COMPACT} from '../../../../constants';

export const Root = styled(Box, {
  shouldForwardProp: prop => prop !== 'isCompact',
})<FullnessProps>(({theme, isCompact}) => ({
  width: '180px',
  height: isCompact ? BLOCK_HEIGHT_COMPACT : BLOCK_HEIGHT,
  flexShrink: 0,
  background: theme.palette.semantic_dark?.surface.surface1,
  position: 'relative',
  borderRadius: '8px',
  overflow: 'hidden',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const Content = styled(Box)(({theme}) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
  position: 'relative',
  zIndex: 10,
}));

export const Header = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  paddingLeft: theme.spacing(2),
}));

export const HeaderText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.onSurface,
  fontSize: '18px',
  fontWeight: 500,
  lineHeight: '22px',
}));

export const HeaderWithIcon = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),

  '.MuiSvgIcon-root': {
    fontSize: '22px',
  },
}));

export const ButtonsBox = styled(Box)(({theme}) => ({
  display: 'flex',
  borderTop: `1px solid ${theme.palette.semantic_dark?.surface.background}`,

  '> *:not(:last-child)': {
    borderRight: `1px solid ${theme.palette.semantic_dark?.surface.background}`,
  },
}));

export const ExpandButton = styled(Button)(({theme}) => ({
  width: '48px',
  minWidth: 'unset',
  height: '32px',
  padding: theme.spacing(0, 4),
  borderRadius: 0,
  background: theme.palette.semantic_dark?.surface.surface2,

  '.MuiSvgIcon-root': {
    color: theme.palette.semantic_dark?.surface.onSurface,
    fontSize: '16px',
  },

  '&:hover': {
    background: theme.palette.semantic_dark?.surface.surface3,
  },
}));

export const HelpButton = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 20,
}));

export const TooltipPaper = styled(Box)(({theme}) => ({
  background: theme.palette.semantic_dark?.surface.inverseSurface,
  borderRadius: '8px',
  padding: theme.spacing(4),
}));

export const BigReadyButton = styled(Button)(({theme}) => ({
  width: '100%',
  height: '100%',
  gap: theme.spacing(2),
  position: 'relative',
  zIndex: 10,
  background: theme.palette.semantic_dark?.surface.surface2,

  '.MuiSvgIcon-root': {
    color: theme.palette.semantic_dark?.surface.onSurface,
    fontSize: '22px',
  },

  '&:hover': {
    background: theme.palette.semantic_dark?.surface.surface3,
  },
}));
